module.exports = __webpack_public_path__ + "static/media/screenshot1.aa409a35.jpg";